import React, { useEffect, useState } from 'react';
import { dbDateToTimestamp, parseEntities, toLongDateDisplay, parseDateDesktopShort } from '../../utils/helpers';
import Tag from './Tag';
import AgendaIcon from '../svg/AgendaIcon';
import DateArrow from '../svg/DateArrow';
import { showTicketButtons, isFriendPage } from '../../../../vriendenverkoop/vriendenverkoop';
// import isFriendPage from '../../../../vriendenverkoop/vriendenverkoop';



const Card = ({ element, setTagsParam, config }) => {
	const [releaseDate, setReleaseDate] = useState('');
	const [endDate, setEndDate] = useState('');

  	useEffect(() => {
		if ('date_range' in element && element.date_range[0]) {
			const date = dbDateToTimestamp(element.date_range[0] + '0000');
			setReleaseDate(date);
		}
		if ('times' in element) {
			const enddate = dbDateToTimestamp(element.times[0].program_end + '0');
			setEndDate(enddate);
		}
	});

	useEffect(() => {
		if ('dates' in element && element.dates.release) {
			const date = dbDateToTimestamp(element.dates.release + '0000');
			setReleaseDate(date);
		}
	}, []);
	let friendType = element.friend_type;
	if ( isFriendPage( friendType ) ) {
	useEffect(() => {
		showTicketButtons( friendType );
		}, []);
	}

	const handleTagClick = (value, onlyActivate) => {
		setTagsParam(value, onlyActivate);
	};

  	return (
		<a className="agenda-card " href={element.permalink}>
			<div className="agenda-card__header">
				<div className="agenda-card__img-container">
					<img src={element.poster_mobile ? element.poster_mobile : element.poster_desktop} alt="" className="agenda-card__img" />
				</div>
				<div className="agenda-card__content-faq">
					<div className="agenda-card__tags">
							{element.tags?.categories &&
								Object.keys(element.tags.categories).map((category, index) => <Tag key={index} tagText={element.tags.categories[category]} displayIcon={false} classname="agenda-card__tag" />)}
					</div>
					{releaseDate && (
						<time dateTime={toLongDateDisplay(parseDateDesktopShort(releaseDate))} className="agenda-card__date subtitle-small">
							<AgendaIcon /> <span className="subtitle-small agenda-card__date-text"> {toLongDateDisplay(parseDateDesktopShort(releaseDate))}</span>{' '}
							{endDate && endDate !== releaseDate && (
							<>
								<DateArrow />
								<span className="subtitle-small agenda-card__date-text"> {toLongDateDisplay(parseDateDesktopShort(endDate))}</span>
							</>
							)}
						</time>
					)}
				</div>
			</div>


			<div className="agenda-card__content">
				<div className="agenda-card__faq-m">
					<div className="agenda-card__tags">
						{element.tags?.categories &&
							Object.keys(element.tags.categories).map((category, index) => <Tag key={index} tagText={element.tags.categories[category]} displayIcon={false} classname="agenda-card__tag" />)}
					</div>

					{releaseDate && (
						<time dateTime={toLongDateDisplay(parseDateDesktopShort(releaseDate))} className="agenda-card__date subtitle-small">
							<AgendaIcon /> <span className="subtitle-small agenda-card__date-text"> {toLongDateDisplay(parseDateDesktopShort(releaseDate))}</span>{' '}
							{endDate && endDate !== releaseDate && (
							<>
								<DateArrow />
								<span className="subtitle-small agenda-card__date-text"> {toLongDateDisplay(parseDateDesktopShort(endDate))}</span>
							</>
							)}
						</time>
					)}
				</div>

				<h2 className="agenda-card__title">{parseEntities(element.title)}</h2>

				<div className="agenda-card__time-place">
					<p className="time__text subtitle-small">{`${element.times[0].program_start.substring(8, 10)}:${element.times[0].program_start.substring(10, 12)} uur -\u00A0`}</p>
					<p className="location subtitle-small"> {Object.values(element.times[0].location)[0]}</p>
				</div>
			</div>
			{/* it should only be an <a> element when ticket link is available */}
			{element.times[0].available && element.times[0].ticket_link
				? element.times[0].status_label && (
						<a href={element.times[0].ticket_link} className={`agenda-card__button ${element.times[0].friend_link ? 'btn--has-friend-link' : ''}`}>
							<p className="agenda-card__button-text label">{element.times[0].status_label}</p>
						</a>
					)
				: element.times[0].status_label && (
						<div className={`agenda-card__button agenda-card__button--inactive ${element.times[0].friend_link ? 'btn--has-friend-link' : ''}`}>
							<p className="agenda-card__button-text agenda-card__button-text--inactive label">{element.times[0].status_label}</p>
						</div>
			)}
			{element.times[0].friend_link && (
			<a href={element.times[0].friend_link} className={`agenda-card__button hide btn--friend-sale-${element.friend_type}`}>
				<p className="agenda-card__button-text label">Tickets</p>
			</a>
			)}

			<div className="grd-corner --no-fill">
				<div className="grd-corner-line"></div>
					<svg className="grd-corner-svg" width="84" height="22" viewBox="0 0 84 22" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M81 3L66.9436 11.8503C58.4871 17.1748 48.6976 20 38.7045 20H32.5H2" stroke="url(#paint0_linear_27_2)" strokeWidth="3" strokeLinecap="square" />
						<defs>
							<linearGradient id="paint0_linear_27_2" x1="50.5" y1="19.9993" x2="-819" y2="-229.501" gradientUnits="userSpaceOnUse">
							<stop stopColor="white" stopOpacity="0.2" />
							<stop offset="1" stopColor="white" stopOpacity="0" />
							</linearGradient>
						</defs>
					</svg>
				</div>
		</a>
	);
};

export default Card;
